import {
  CustomerGroupType,
  minimalCustomerGroupSchema,
} from "@redotech/redo-model/customers/customer-group-definition";
import * as z from "zod/v4";

export const getCustomerGroupsMinimal = {
  name: "getCustomerGroupsMinimal" as const,
  input: z.object({ type: z.nativeEnum(CustomerGroupType).optional() }),
  output: z.array(minimalCustomerGroupSchema),
};
